<template>
  <div class="mx-auto col-sm-8">
    <div class="row">
      <div class="form-group col-lg-12">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          :options="arenaClients"
          v-model="clientSelected"
          :initial-value="clientSelected"
          v-validate="'required'"
          :hasErrors="errors.has('client')"
          :getOptionLabel="(client) => `${client.CLI_ID} - ${client.CLI_DSC}`"
        />

        <small v-show="errors.has('client')" class="form-text">
          {{ errors.first('client') }}
        </small>
      </div>
    </div>

    <div class="row">
      <LoaderButton
        class="ml-3"
        @click="create"
        :disabled="!clientSelected"
      >
        Criar
      </LoaderButton>
    </div>
  </div>
</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import { mapState } from 'vuex/dist/vuex.common.js'

export default {
  name: 'UserWebServiceADD',
  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      clientSelected: undefined,
    }
  },

  computed: {
    ...mapState({
      arenaClients: state => state.arena.clients
    })
  },

  methods: {
    async create() {
      const { dispatch } = this.$store

      const isValid = await this.$validator.validateAll()

      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))

        return dispatch('notify/error', err)
      }

      await this.$store.dispatch('arena/createUserWebService', this.clientSelected.CLI_ID)
    }
  },

  mounted () {
    this.$store.dispatch('arena/fetchClients')
  },
}

</script>
